import gql from 'graphql-tag';

export const sessionReportCommentFieldsFragment = gql`
  fragment AdminSessionReportCommentFields on SessionReportComment {
    name
    comment
  }
`;